<template>
  <vxe-modal v-model="visible" :destroyOnClose="true" :loading="loading" :title="$t('title.asnDetailEdit')" show-footer size="mini" type="confirm" width="60%" @cancel="handleCancel" @confirm="handleOk">
    <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="detail" :rules="rules" :wrapper-col="wrapperCol">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.itemNo')" prop="itemNo">
            <a-input v-model="detail.item.no" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.itemName')" prop="itemName">
            <a-input v-model="detail.item.name" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.arrivalQuantity')" prop="quantity">
            <a-input-number v-model="detail.quantity" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.specification')" prop="specification">
            <a-input-search v-model="detail.pack.specification" readOnly @dblclick="onPackSelect" @search="onPackSelect"/>
            <pack-modal ref="packModal" @change="onPackChange"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.uom')" prop="uom">
            <a-input v-model="detail.pack.uom" disabled/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.factor')" prop="factor">
            <a-input v-model="detail.pack.factor" disabled/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.lot')" prop="lotNo">
            <a-input v-model="detail.lotNo"
                     @dblclick="()=>this.$refs.lotModal.open({'item.id':detail.item.id})"
                     @pressEnter="()=>this.$refs.lotModal.open({'item.id':detail.item.id})"
                     @search="()=>this.$refs.lotModal.open({'item.id':detail.item.id})"/>
            <lot-modal ref="lotModal"
                       @change="(e)=>{
                           detail.lotNo= e.length===0? null : e[0].no
                           detail.validUntil= e.length===0? null : e[0].validUntil
                           detail.productionDate= e.length===0? null : e[0].productionDate
                           detail.manufacturer= e.length===0? null : e[0].manufacturer
                           detail.producingArea= e.length===0? null : e[0].producingArea
                           detail.approvalNo= e.length===0? null : e[0].approvalNo
                           detail.license= e.length===0? new License() : Object.assign(new License(),e[0].license)
                           detail.practice= e.length===0? new Practice() : Object.assign(new Practice(),e[0].practice)
                           detail.permission= e.length===0? new Permission() : Object.assign(new Permission(),e[0].permission)
                           detail.quality= e.length===0? new Quality() : Object.assign(new Quality(),e[0].quality)
                         }"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.productionDate')" prop="productionDate">
            <a-date-picker v-model="detail.productionDate" format="YYYY-MM-DD" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.validUntil')" prop="validUntil">
            <a-date-picker v-model="detail.validUntil" format="YYYY-MM-DD" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.manufacturer')" prop="manufacturer">
            <a-select v-model="detail.manufacturer" allowClear style="width: 100%">
              <a-select-option v-for="data in manufacturers" :key="data">{{data}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.producingArea')" prop="producingArea">
            <a-select v-model="detail.producingArea" allowClear style="width: 100%">
              <a-select-option v-for="data in producingAreas" :key="data">{{data}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.approvalNo')" prop="approvalNo">
            <a-input-search v-model="detail.approvalNo"
                            readOnly
                            @dblclick="()=>this.$refs.approvalModal.open({'itemId':detail.item.id})"
                            @search="()=>this.$refs.approvalModal.open({'itemId':detail.item.id})"/>
            <approval-modal ref="approvalModal" @change="(e)=>{
                $nextTick(() => {
                  detail.approvalNo=e.length===0?null:e[0].approvalNo
                })
              }"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.licenseNo')" prop="license">
            <a-input-search v-model="detail.license.licenseNo"
                            readOnly
                            @dblclick="()=>this.$refs.licenseModal.open({'itemId':detail.item.id})"
                            @search="()=>this.$refs.licenseModal.open({'itemId':detail.item.id})"/>
            <license-modal ref="licenseModal" @change="(e)=>{ detail.license=e.length===0?new License():Object.assign(new License(),e[0]) }"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.permissionNo')" prop="permission">
            <a-input-search v-model="detail.permission.permissionNo"
                            readOnly
                            @dblclick="()=>this.$refs.permissionModal.open({'itemId':detail.item.id})"
                            @search="()=>this.$refs.permissionModal.open({'itemId':detail.item.id})"/>
            <permission-modal ref="permissionModal" @change="(e)=>{ detail.permission=e.length===0?new Permission():Object.assign(new Permission(),e[0]) }"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.practiceNo')" prop="practice">
            <a-input-search v-model="detail.practice.practiceNo"
                            readOnly
                            @dblclick="()=>this.$refs.practiceModal.open({'itemId':detail.item.id})"
                            @search="()=>this.$refs.practiceModal.open({'itemId':detail.item.id})"/>
            <practice-modal ref="practiceModal" @change="(e)=>{ detail.practice=e.length===0?new Practice():Object.assign(new Practice(),e[0]) }"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.qualityStandard')" prop="quality">
            <a-input-search v-model="detail.quality.qualityStandard"
                            readOnly
                            @dblclick="()=>this.$refs.qualityModal.open({'itemId':detail.item.id})"
                            @search="()=>this.$refs.qualityModal.open({'itemId':detail.item.id})"/>
            <quality-modal ref="qualityModal" @change="(e)=>{ detail.quality=e.length===0?new Quality():Object.assign(new Quality(),e[0]) }"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.departureTemp')" prop="departureTemp">
            <a-input-number v-model="detail.temperature.departureTemp" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.arrivalTemp')" prop="arrivalTemp">
            <a-input-number v-model="detail.temperature.arrivalTemp" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.maximumTemp')" prop="maximumTemp">
            <a-input-number v-model="detail.temperature.maximumTemp" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item :label="$t('business.label.minimumTemp')" prop="minimumTemp">
            <a-input-number v-model="detail.temperature.minimumTemp" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import { post } from '@/api/Api'
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import ACol from 'ant-design-vue/es/grid/Col'
import ARow from 'ant-design-vue/es/grid/Row'
import { AsnDetail, AsnOrder } from '@/api/dto/order/AsnOrder'
import PackModal from '@/views/modal/PackModal.vue'
import { Pack } from '@/api/dto/common/Pack'
import LotModal from '@/views/modal/LotModal.vue'
import { License } from '@/api/dto/valueobject/License'
import { Practice } from '@/api/dto/valueobject/Practice'
import { Permission } from '@/api/dto/valueobject/Permission'
import { Quality } from '@/api/dto/valueobject/Quality'
import ApprovalModal from '@/views/inbound/asn/modal/ApprovalModal.vue'
import LicenseModal from '@/views/inbound/asn/modal/LicenseModal.vue'
import PermissionModal from '@/views/inbound/asn/modal/PermissionModal.vue'
import PracticeModal from '@/views/inbound/asn/modal/PracticeModal.vue'
import QualityModal from '@/views/inbound/asn/modal/QualityModal.vue'
import Api from '@/api'

export default {
  name: 'AsnDetailEditModal',
  computed: {
    Quality() {
      return Quality
    },
    Permission() {
      return Permission
    },
    Practice() {
      return Practice
    },
    License() {
      return License
    },
    Pack() {
      return Pack
    }
  },
  components: {
    QualityModal,
    PracticeModal,
    PermissionModal,
    LicenseModal,
    ApprovalModal,
    LotModal,
    PackModal,
    ARow,
    ACol
  },
  data() {
    return {
      visible: false,
      loading: false,
      warehouse: Vue.ls.get(WAREHOUSE),
      isAdd: false,
      isEdit: false,
      order: new AsnOrder(),
      detail: new AsnDetail(),
      manufacturers: [],
      producingAreas: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {}
    }
  },
  methods: {
    open(order, detail) {
      this.order = order
      this.detail = detail
      this.manufacturers = detail.item.manufacturer.split(',')
      this.producingAreas = detail.item.producingArea.split(',')
      this.visible = true
      this.isAdd = false
      this.isEdit = true
    },
    onPackSelect() {
      this.$refs.packModal.open({ 'item.id': this.detail.item.id })
    },
    onPackChange(data) {
      this.detail.pack = new Pack(data[0])
    },
    save() {
      this.loading = true
      const order = this.order.toJSONObject()
      order.details = [this.detail.toJSONObject()]
      post(Api.receivingAsnSave, { type: 'normalAsn' }, order).then(res => {
        if (res.success) {
          this.$message.success('保存成功')
          this.$emit('success', res.result)
          this.handleCancel()
        }
      }).finally(() => this.loading = false)
    },
    handleOk() {
      this.$refs.form.validate((success) => {
        if (success) {
          this.save()
        }
      })
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>